/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { IElectricityPayment } from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';

type Props = {
  Report: IElectricityPayment[];
};

export default function ElectricityPaymentBillPDF({ Report }: Props) {
  const recordsPerPage = 3;
  const { translate } = useLocales();
  const [dirction, setDirection] = useState('ltr');
  const lang = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (lang === 'ps' || lang === 'dr') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }
  }, [lang]);

  if (Report.length === 0) {
    return <Loader />;
  }

  const width = 'w-[240mm]';
  const totalPages = Math.ceil(Report.length / recordsPerPage);

  return (
    <div className="px-7">
      {Report.length > 0 ? (
        <div className={`${width} h-[297mm] mx-auto bg-white text-black`} dir={dirction}>
          {Array.from({ length: totalPages }).map((_, pageIndex) => (
            <div key={pageIndex} className="page-break  mt-10 ">
              <div className="bill-container print:flex print:flex-col print:text-black" style={{
                pageBreakInside: 'avoid',
                direction: 'rtl',
                height: '140mm',        // ارتفاع ثابت
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}>
                {Report.slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage).map(
                  (record: IElectricityPayment, rowIndex: number) => (
                    <div key={rowIndex} className="flex justify-between mr-6 mb-7 ">
                      {[1, 2].map((copy) => (
                        <div
                          key={copy}
                          className="bill-card border border-black rounded-md p-3  w-[48%] text-xs"
                          style={{ pageBreakInside: 'avoid', direction: 'rtl' }}
                        >
                          {/* Logo and Header */}
                          <div className="flex justify-between items-center  mb-2">
                            {/* Text (Left side) */}
                            <div className="text-right font-bold leading-5">
                              <span className="text-2xl">مرکز تجارتی چقرک</span>

                              <br />
                              <span className="text-md">
                                بل مصرفیه برق ماه {GetMonthName(record.month, 'dr')} ({record.year})
                                <br />
                                <span>نمبر میتر: ({record.electricMeterSerial})</span>
                                <span className="px-2">|</span>
                                <span>صندوق: {record.electricBoxCode}</span>
                                <span className="px-2">|</span>
                                <span>دوکان: {record.shopCode}</span>
                              </span>
                            </div>

                            {/* Logo (Right side) */}
                            <div className="flex-shrink-0">
                              <img
                                src={require('src/assets/Choqorak/logo1.png')}
                                width="100"
                                height="100"
                                alt="logo"
                                className="ml-2"
                              />
                            </div>
                          </div>

                          {/* Customer Name */}
                          {/* {record.contractNumber && ( */}
                          <div
                            className="
                               text-center font-semibold my-2 text-lg py-2
                               min-h-[3.5rem] leading-snug line-clamp-2
                               "
                          >
                            {record.contractNumber ? (
                              <>
                                محترم {record.customerPashtoName || '...'} ولد{' '}
                                {record.customerPashtoFatherName || '...'} (
                                {record.contractNumber || '...'})
                              </>
                            ) : '...'}
                          </div>
                          {/* )} */}

                          {/* Table Info */}
                          <div className="border-t border-b mt-2 pt-2 text-sm">
                            <div className="flex justify-between border-b border-dashed py-2">
                              <span style={{ fontSize: '18px' }}>کیلوات گذشته:</span>
                              <span style={{ fontSize: '18px' }}>
                                {record.previousElectricMeterDegree || 0} Kw
                              </span>
                            </div>
                            <div className="flex justify-between border-b border-dashed py-2">
                              <span style={{ fontSize: '18px' }}>کیلوات حالیه</span>
                              <span style={{ fontSize: '18px' }}>
                                {record.currentElectricMeterDegree || 0} Kw
                              </span>
                            </div>
                            <div className="flex justify-between border-b border-dashed py-2">
                              <span style={{ fontSize: '18px' }}>مبلغ قابل پرداخت</span>
                              <span style={{ fontSize: '18px' }}>
                                {record.currentDateRangePayment || 0} AF
                              </span>
                            </div>
                            <div className="flex justify-between border-b border-dashed py-2">
                              <span style={{ fontSize: '18px' }}>باقیات گذشته</span>
                              <span style={{ fontSize: '18px' }}>
                                {record.remnantsOfThePast || 0} AF
                              </span>
                            </div>
                            <div className="flex justify-between font-bold py-2">
                              <span style={{ fontSize: '18px' }}>جمله مبلغ قابل پرداخت</span>
                              <span style={{ fontSize: '18px' }}>{record.totalPayment} AF</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center">
          {translate('ReceptionDashboard.NoRecordFound')}
        </div>
      )}
    </div>
  );
}
